module.exports = __webpack_public_path__ + "static/media/swimmy-story-pool.13f15a25.png";